// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
import { SystemStatsFragmentDoc } from "../SystemStats/gql/Fragment.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type ServerDashboardQueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
}>;

export type ServerDashboardQuery = {
  __typename?: "GraphqlQuery";
  getServerDetails: {
    __typename?: "Server";
    id: string;
    humanId: string;
    name: string;
    systemType?: string | null;
    lastSnapshotAt?: number | null;
    tags: Array<{
      __typename?: "ServerTag";
      key: string;
      value: string;
      source: string;
    }>;
  };
  getIssues: Array<{
    __typename?: "Issue";
    id: string;
    checkGroupAndName: string;
    databaseId?: string | null;
    state: string;
    descriptionTemplate: string;
    queryText?: string | null;
    severity: string;
    descriptionReferences: Array<{
      __typename?: "IssueDescriptionReference";
      param: string;
      name: string;
    }>;
  }>;
  getSystemDetails: {
    __typename?: "SystemDetails";
    info?: {
      __typename?: "SystemInfo";
      systemType?: string | null;
      data?: {
        __typename?: "SystemInfoData";
        instanceClass?: string | null;
        instanceId?: string | null;
        region?: string | null;
        status?: string | null;
      } | null;
    } | null;
    stats?: {
      __typename?: "SystemStats";
      cpuHardwareModel?: string | null;
      cpuHardwareSockets?: number | null;
      cpuHardwareCoresPerSocket?: number | null;
      cpuHardwareSpeedMhz?: number | null;
      cpuHardwareCacheSize?: number | null;
      schedulerLoadavg1min?: number | null;
      schedulerLoadavg5min?: number | null;
      schedulerLoadavg15min?: number | null;
      memoryTotalBytes?: number | null;
      memoryApplicationBytes?: number | null;
      memoryFreeBytes?: number | null;
      storageBytesTotal?: number | null;
      storageBytesAvailable?: number | null;
    } | null;
  };
};

export const ServerDashboardDocument = gql`
  query ServerDashboard($serverId: ID!) {
    getServerDetails(serverId: $serverId) {
      id
      humanId
      name
      systemType
      lastSnapshotAt
      tags {
        key
        value
        source
      }
    }
    getIssues(serverId: $serverId, databaseId: null) {
      id
      checkGroupAndName
      databaseId
      state
      descriptionTemplate
      descriptionReferences {
        param
        name
      }
      queryText
      severity
    }
    getSystemDetails(serverId: $serverId) {
      ...SystemStats
    }
  }
  ${SystemStatsFragmentDoc}
`;

/**
 * __useServerDashboardQuery__
 *
 * To run a query within a React component, call `useServerDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useServerDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServerDashboardQuery({
 *   variables: {
 *      serverId: // value for 'serverId'
 *   },
 * });
 */
export function useServerDashboardQuery(
  baseOptions: Apollo.QueryHookOptions<
    ServerDashboardQuery,
    ServerDashboardQueryVariables
  > &
    (
      | { variables: ServerDashboardQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ServerDashboardQuery, ServerDashboardQueryVariables>(
    ServerDashboardDocument,
    options,
  );
}
export function useServerDashboardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ServerDashboardQuery,
    ServerDashboardQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ServerDashboardQuery,
    ServerDashboardQueryVariables
  >(ServerDashboardDocument, options);
}
// @ts-ignore
export function useServerDashboardSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ServerDashboardQuery,
    ServerDashboardQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ServerDashboardQuery,
  ServerDashboardQueryVariables
>;
export function useServerDashboardSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServerDashboardQuery,
        ServerDashboardQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ServerDashboardQuery | undefined,
  ServerDashboardQueryVariables
>;
export function useServerDashboardSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServerDashboardQuery,
        ServerDashboardQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ServerDashboardQuery,
    ServerDashboardQueryVariables
  >(ServerDashboardDocument, options);
}
export type ServerDashboardQueryHookResult = ReturnType<
  typeof useServerDashboardQuery
>;
export type ServerDashboardLazyQueryHookResult = ReturnType<
  typeof useServerDashboardLazyQuery
>;
export type ServerDashboardSuspenseQueryHookResult = ReturnType<
  typeof useServerDashboardSuspenseQuery
>;
export type ServerDashboardQueryResult = Apollo.QueryResult<
  ServerDashboardQuery,
  ServerDashboardQueryVariables
>;
